import { CommonModule } from "@angular/common";
import {
    AfterViewInit,
    Component,
    computed,
    ElementRef,
    inject,
    model,
    viewChild,
} from "@angular/core";
import { ModalAdapter } from "../modal/modal.adapter";
import { ActionSheetService } from "./action-sheet.service";
import { ActionSheetOption } from "./action-sheet.type";
import { ActionSheetHeader } from "./header/action-sheet-header.component";
import { ActionSheetOptionComponent } from "./option/action-sheet-option.component";
import { ActionSheetMultipleOptionComponent } from "./multiple-option/action-sheet-multiple-option.component";
import { Button } from "../button/button.component";

@Component({
    selector: "app-action-sheet",
    standalone: true,
    templateUrl: "./action-sheet.component.html",
    imports: [
        CommonModule,
        ActionSheetOptionComponent,
        ActionSheetMultipleOptionComponent,
        ActionSheetHeader,
        Button,
    ],
})
export default class ActionSheetComponent
    extends ModalAdapter
    implements AfterViewInit
{
    actionSheetRef = viewChild<ElementRef<HTMLElement>>("actionSheet");
    options = computed<ActionSheetOption[]>(() => this.props()?.options || []);
    title = computed<string>(() => this.props()?.title || "");
    renderItem = computed<any>(() => this.props()?.renderItem || "");
    currentValue = computed<any>(() => this.props()?.currentValue || "");
    multiple = computed<boolean>(() => this.props()?.multiple || false);
    multipleValues = computed<any[]>(() =>
        Array.isArray(this.currentValue()) ? this.currentValue() : [],
    );

    readonly actionSheetService = inject(ActionSheetService);

    values = model<any[]>([]);

    ngAfterViewInit(): void {
        this.values.set(this.multipleValues());

        this.actionSheetRef()?.nativeElement.animate(
            [
                { opacity: 0, transform: "translateY(10px)" },
                { opacity: 1, transform: "translateY(0)" },
            ],
            {
                duration: 200,
                easing: "ease-in-out",
            },
        );
    }

    handleClick(option: ActionSheetOption) {
        if (!this.multiple()) {
            this.actionSheetService.close(option.value);

            if (option.handler) {
                option.handler();
            }
        } else {
            if (this.values().includes(option.value)) {
                this.values.set(
                    this.values().filter((v) => v !== option.value),
                );
            } else {
                this.values.set([...this.values(), option.value]);
            }
        }
    }

    apply() {
        this.actionSheetService.close(this.values());
    }

    reset() {
        this.values.set([]);
    }

    cancel() {
        this.actionSheetService.close("cancel");
    }
}
